<template>
<div :class="`callout callout-${calloutPosition} ${calloutAuthorType}`" >
    <div class="callout-bg">
        <div class="callout-img">
            <img class="lazyload" :alt="`${alternativeText}`" border="0" :data-src="`${staticAssetPath}/img/ornish/${calloutImgName}`" />
        </div>
        <div class="callout-quote">{{calloutQuote}}</div>
        <div class="callout-author">
            <div class="callout-author-name">{{calloutAuthorName}}</div>
            <div class="callout-author-title">{{calloutAuthorTitle}}</div>
            <div class="callout-author-type">{{calloutAuthorType}}</div>
        </div><!-- end of callout-author -->
    </div>
</div>  <!-- end of callout -->
</template>

<script>
export default {
  name: 'TestimonialCarouselCallout',
  data () {
        return {
          staticAssetPath: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_ASSETS_URL,
        }
    },
  props: {
    calloutPosition: {
        type: String,
        default: ''
    },
    calloutImgName: {
        type: String,
        default: ''
    },
    calloutQuote: {
        type: String,
        default: ''
    },
    calloutAuthorName: {
        type: String,
        default: ''
    },
    calloutAuthorTitle: {
        type: String,
        default: ''
    },
    calloutAuthorType: {
        type: String,
        default: ''
    },
    alternativeText: {
        type: String,
        default: ''
    }
  }
}
</script>